import { Building2, Mail, Sparkles, CreditCard, MessageSquare, CalendarCheck } from 'lucide-react';

// Open de Instellingen-pagina op een specifieke tab.
export const openSettingsTab = (onNavigate, tab) => {
  try { sessionStorage.setItem('mc_open_settings_tab', tab); } catch (_) { /* noop */ }
  onNavigate('instellingen');
};

// Metadata per onboarding-stap. t = vertaalfunctie uit useT().
export const buildStepMeta = (t) => ({
  gegevens: {
    icon: Building2, proOnly: false,
    title: t('Garagegegevens & logo', 'Garagegegevens & logo'),
    desc: t('Vul je adres, KvK, BTW-nummer en IBAN in en upload je logo. Deze gegevens verschijnen op je facturen en e-facturen.', 'Vul je adres, KvK, BTW-nummer en IBAN in en upload je logo. Deze gegevens verschijnen op je facturen en e-facturen.'),
    nav: (onNavigate) => onNavigate('gegevens'),
  },
  email: {
    icon: Mail, proOnly: false,
    title: t('E-mail versturen instellen', 'E-mail versturen instellen'),
    desc: t('Koppel je e-mail (SMTP) zodat facturen en herinneringen vanuit je eigen adres verstuurd worden.', 'Koppel je e-mail (SMTP) zodat facturen en herinneringen vanuit je eigen adres verstuurd worden.'),
    nav: (onNavigate) => openSettingsTab(onNavigate, 'smtp'),
  },
  ai: {
    icon: Sparkles, proOnly: false,
    title: t('AI inschakelen (Google Gemini)', 'AI inschakelen (Google Gemini)'),
    desc: t('Plak je gratis Google Gemini-sleutel voor AI-diagnose, bonnen scannen (OCR) en automatische samenvattingen.', 'Plak je gratis Google Gemini-sleutel voor AI-diagnose, bonnen scannen (OCR) en automatische samenvattingen.'),
    link: { url: 'https://aistudio.google.com/apikey', label: 'aistudio.google.com/apikey' },
    nav: (onNavigate) => openSettingsTab(onNavigate, 'licentie'),
  },
  betalen: {
    icon: CreditCard, proOnly: false,
    title: t('Online betalen (Stripe)', 'Online betalen (Stripe)'),
    desc: t('Koppel Stripe zodat klanten je facturen online met iDEAL of creditcard kunnen betalen via een betaallink.', 'Koppel Stripe zodat klanten je facturen online met iDEAL of creditcard kunnen betalen via een betaallink.'),
    link: { url: 'https://dashboard.stripe.com/apikeys', label: 'dashboard.stripe.com' },
    nav: (onNavigate) => openSettingsTab(onNavigate, 'betalen'),
  },
  twilio: {
    icon: MessageSquare, proOnly: true,
    title: t('SMS/WhatsApp-herinneringen (Twilio)', 'SMS/WhatsApp-herinneringen (Twilio)'),
    desc: t('Maak een Twilio-account, kopieer je Account SID + Auth Token en een afzendernummer en vul ze in. Klanten krijgen dan automatisch een herinnering vóór hun afspraak.', 'Maak een Twilio-account, kopieer je Account SID + Auth Token en een afzendernummer en vul ze in. Klanten krijgen dan automatisch een herinnering vóór hun afspraak.'),
    link: { url: 'https://www.twilio.com/console', label: 'twilio.com/console' },
    nav: (onNavigate) => onNavigate('smsherinneringen'),
  },
  afspraken: {
    icon: CalendarCheck, proOnly: true,
    title: t('Online afspraken & klantportaal', 'Online afspraken & klantportaal'),
    desc: t('Zet online afspraken aan zodat klanten 24/7 zelf boeken, en deel je klantportaal-link zodat ze hun facturen en afspraken kunnen bekijken.', 'Zet online afspraken aan zodat klanten 24/7 zelf boeken, en deel je klantportaal-link zodat ze hun facturen en afspraken kunnen bekijken.'),
    nav: (onNavigate) => onNavigate('onlineafspraken'),
  },
});
